<template>
  <div class="fixed-bar--bar quote-navigation-bar" :class="themeClassName">
    <ul>
      <li>
        <a @click="scrollTo('contractFleet')">
          {{ i18n.t('/quotepage/navigationbar/contractfleet') }}
        </a>
      </li>
      <li>
        <a @click="scrollTo('controlCodes')">
          {{ i18n.t('/quotepage/navigationbar/controlcodes') }}
        </a>
      </li>
      <li>
        <a @click="scrollTo('dealerOptions')">
          {{ i18n.t('/quotepage/navigationbar/dealeroptions') }}
        </a>
      </li>
      <li>
        <a @click="scrollTo('financing')">
          {{ i18n.t('/quotepage/navigationbar/financing') }}
        </a>
      </li>
      <li v-if="canViewVcr">
        <a @click="goToVCR()">
          {{ i18n.t('/quotepage/navigationbar/vcr') }}
        </a>
      </li>
      <li>
        <financial-overview-modal trigger-type="link" />
      </li>
    </ul>
  </div>
</template>

<script>
import FinancialOverviewModal from '@/components/generic/presentational/organisms/financialOverview/FinancialOverviewModal.vue'
import { mapGetters } from 'vuex'
import { getBrandName } from '@/helpers/BrandHelper'

export default {
  components: {
    FinancialOverviewModal,
  },
  emits: ['scroll-to'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      quote: 'quote/get',
      canViewVcr: 'user/canViewVcr',
    }),
    themeClassName() {
      return `theme-${getBrandName()}`
    },
  },
  methods: {
    scrollTo(ref) {
      this.$emit('scroll-to', ref)
    },
    goToVCR() {
      this.$router.push({
        name: 'vcr-page',
        params: {
          establishmentId: this.$route.params.establishmentId,
          customerTyper: this.$route.params.customerType,
          quoteId: this.quote.QuoteId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-navigation-bar {
  ul {
    width: 100%;
    list-style-type: none;
    display: flex;
    justify-content: space-around;

    & > li {
      flex: 1;
      border-right: 1px solid $white;
      padding: 0.5rem 0;
      background-color: $color-primary;

      &:hover {
        background-color: $color-primary-dark;
      }

      :deep(a) {
        color: $white;
        display: block;
        text-align: center;
      }

      &:last-child {
        border-right: 0;
      }

      :deep(.financial-overview) {
        zoom: 70%;
      }
    }
  }
}
</style>
